import React from "react";
import moment from "moment";
import "moment/locale/pt-br";

import { Empty, Table, Tooltip } from "antd";

import { User as UserModel } from "../../models/entities/user";
import { UserAudit } from "../../models/entities/userAudit";

import {
  Modal,
  OldValueContainer,
  OldValueBadge,
  ArrowIcon,
  NewValueBadge,
} from "./styles";

interface IProps {
  visible: boolean;
  loading: boolean;
  auditData: UserAudit[];
  selectedUser: UserModel | null;
  onClose: () => void;
}

const ModalAuditUser: React.FC<IProps> = ({
  visible,
  loading,
  auditData,
  selectedUser,
  onClose,
}) => {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "8%",
    },
    {
      title: "Data da alteração",
      dataIndex: "created_at",
      key: "created_at",
      width: "17%",
      render: (text) => {
        const formattedDate = moment(text).format("DD/MM/YYYY HH:mm:ss");
        return <span>{formattedDate}</span>;
      },
    },
    {
      title: "Campo",
      dataIndex: "field",
      key: "field",
      width: "15%",
      render: (text) => (
        <span style={{ textTransform: "capitalize" }}>
          {text?.replace(/_/g, " ")}
        </span>
      ),
    },
    {
      title: "Valor Antigo",
      dataIndex: "old_value",
      key: "old_value",
      width: "23%",
      ellipsis: true,
      render: (text, record) => {
        let displayValue = text || "-";
        if (record.field === "birthday" && text) {
          try {
            const date = moment(text);
            if (date.isValid()) {
              displayValue = date.format("DD/MM/YYYY");
            }
          } catch (error) {
          }
        }
        return (
          <OldValueContainer>
            <Tooltip title={text}>
              <OldValueBadge>{displayValue}</OldValueBadge>
            </Tooltip>
            <ArrowIcon />
          </OldValueContainer>
        );
      },
    },
    {
      title: "Valor Novo",
      dataIndex: "new_value",
      key: "new_value",
      width: "22%",
      ellipsis: true,
      render: (text, record) => {
        let displayValue = text || "-";
        if (record.field === "birthday" && text) {
          try {
            const date = moment(text);
            if (date.isValid()) {
              displayValue = date.format("DD/MM/YYYY");
            }
          } catch (error) {
          }
        }
        return (
          <Tooltip title={text}>
            <NewValueBadge>{displayValue}</NewValueBadge>
          </Tooltip>
        );
      },
    },
    {
      title: "Responsável",
      dataIndex: "user_name",
      key: "user_name",
      width: "10%",
      render: (text) => (
        <span style={{ textTransform: "capitalize" }}>{text}</span>
      ),
    },
  ];

  return (
    <Modal
      title={
        <>
          Auditoria do Usuário -{" "}
          <span style={{ textTransform: "capitalize" }}>
            {selectedUser?.full_name || ""}
          </span>
        </>
      }
      visible={visible}
      centered
      destroyOnClose
      closable
      width={1200}
      footer={null}
      onCancel={onClose}
    >
      {loading ? (
        <Table
          loading={loading}
          columns={columns}
          dataSource={[]}
          scroll={{
            x: 1000,
            y: 400,
          }}
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
          }}
        />
      ) : auditData.length !== 0 ? (
        <Table
          loading={loading}
          columns={columns}
          dataSource={auditData.map((item) => ({ ...item, key: item.id }))}
          scroll={{
            x: 1000,
            y: 400,
          }}
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
          }}
        />
      ) : (
        <Empty description="Não há histórico de auditoria para este usuário!" />
      )}
    </Modal>
  );
};

export default ModalAuditUser;
